var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalkaBelay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.525 0.641768C10.6421 0.758955 10.7078 0.917809 10.7078 1.08343C10.7078 1.24906 10.6421 1.40791 10.525 1.5251L4.69171 7.35843C4.57453 7.47548 4.41567 7.54122 4.25005 7.54122C4.08442 7.54122 3.92557 7.47548 3.80838 7.35843L0.475046 4.0251C0.413641 3.96788 0.364389 3.89888 0.330229 3.82222C0.296069 3.74555 0.277701 3.66279 0.27622 3.57887C0.27474 3.49495 0.290177 3.41159 0.321611 3.33377C0.353045 3.25595 0.399832 3.18525 0.459181 3.1259C0.51853 3.06655 0.589225 3.01977 0.667048 2.98833C0.744872 2.9569 0.82823 2.94146 0.912149 2.94294C0.996068 2.94442 1.07883 2.96279 1.15549 2.99695C1.23216 3.03111 1.30116 3.08036 1.35838 3.14177L4.25005 6.03343L9.64171 0.641768C9.7589 0.524726 9.91776 0.458984 10.0834 0.458984C10.249 0.458984 10.4079 0.524726 10.525 0.641768Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalkaBelay);
export default __webpack_public_path__ + "static/media/galkaBelay.3205e2a5fbe4685a64bed29b75508671.svg";
export { ForwardRef as ReactComponent };